module.exports = __webpack_public_path__ + "img/bicycle.09d40813.svg";